module.exports = __webpack_public_path__ + "static/moon-c65d11074b201bb6f05939a93b4d8cda.png";